<div class="flex flex-col items-center justify-center min-h-screen gap-6">
  <img src="images/logo/logo.png" alt="Logo" width="64" height="64" />
  <h1 class="text-4xl font-bold text-center">{{ titleTranslationKey | translate }}</h1>
  <p class="text-xl text-center">
    {{ 'pages.notFound.description' | translate }}
  </p>
</div>
